import router from '@/router';
import validators from './validators';

interface onboardingHelpers {
  endOnboarding(): void;
  validateAndSubmitUserData(
    arg0: any,
    arg1: string,
    arg2?: 'saveAndQuit' | 'saveAndContinue',
  ): void;
}

const onboardingHelpers: onboardingHelpers = {
  endOnboarding() {
    localStorage.removeItem('onboardingOngoing');

    setTimeout(() => {
      router.push('/assessor-profile');
    }, 100);
  },

  validateAndSubmitUserData(self, formToValidate, saveOption) {
    if (saveOption === 'saveAndQuit') self.saveAndQuit = true;

    validators.validateForm(self, formToValidate);

    if (!self.formIsValid) {
      self.saveAndQuit = false;
      return;
    }

    self.submitUserData();
  },
};

export default onboardingHelpers;
